const SUPPORTED_CAR_TYPE_YEARS = 36;
const SUPPORTED_CARAVAN_TYPE_YEARS = 73;
const SUPPORTED_ELECTRIC_SCOOTER_TYPE_YEARS = 13;
const SUPPORTED_MOPED_TYPE_YEARS = 53;
const SUPPORTED_MOTORCYCLE_TYPE_YEARS = 55;
const SUPPORTED_TRACTOR_TYPE_YEARS = 35;
const SUPPORTED_TRAILER_TYPE_YEARS = 73;

// Thirty years back from today, e.g. Today is 2022 -> valid veteran auto years 1992 - 1910
export const CUSTOM_VETERAN_AUTO_TYPE_YEARS_START = 29;
// Eightytwo years back from CUSTOM_VETERAN_AUTO_TYPE_YEARS_START
export const CUSTOM_VETERAN_AUTO_TYPE_YEARS_END = 83;

export enum VEHICLE_TYPE {
  CAR,
  CARAVAN,
  ELECTRIC_SCOOTER,
  MOPED,
  MOTORCYCLE,
  TRACTOR,
  TRAILER,
  VETERAN_AUTO,
}

export const getVehicleTypeYears = (vehicleType: VEHICLE_TYPE): number => {
  switch (vehicleType) {
    case VEHICLE_TYPE.CARAVAN:
      return SUPPORTED_CARAVAN_TYPE_YEARS;
    case VEHICLE_TYPE.ELECTRIC_SCOOTER:
      return SUPPORTED_ELECTRIC_SCOOTER_TYPE_YEARS;
    case VEHICLE_TYPE.MOPED:
      return SUPPORTED_MOPED_TYPE_YEARS;
    case VEHICLE_TYPE.MOTORCYCLE:
      return SUPPORTED_MOTORCYCLE_TYPE_YEARS;
    case VEHICLE_TYPE.TRACTOR:
      return SUPPORTED_TRACTOR_TYPE_YEARS;
    case VEHICLE_TYPE.TRAILER:
      return SUPPORTED_TRAILER_TYPE_YEARS;
    case VEHICLE_TYPE.CAR:
    default:
      return SUPPORTED_CAR_TYPE_YEARS;
  }
};

export const BRAND_MODEL_MAX_CHARACTER_LENGTH = 20;
export const INSURED_AMOUNT_MAX_CHARACTER_LENGTH = 7;
